import React, {useState, useEffect} from "react";
import { FormGroup, Select, Button, Icon } from "xsolla-uikit";
import { getCountries } from "./PAgkRefund";
import { PArefundsBadge } from "./PArefundsBadge";
import PAContentBlock from "../PAContentBlock";


export const PArefundPreview = ({level = 'loyal'}) => {

  const [loading, setLoading] = useState(false)

  function fakeLoader(time = 2000) {
    const [keys, setKeys] = useState(false);
    useEffect(() => {
      if (!keys) {
        setTimeout(() => {
          setKeys(!keys);
        }, time);
      }
    });
    return keys;
  }


  return (
    <FormGroup indentation="lg">



      <div style={{
          backgroundColor: "#F6F9FE",
          padding: 24,
        }}>
      <FormGroup>

        <FormGroup>
          <div style={{
            display: "flex",
            justifyContent: "space-between"
          }}>
            <Select name={`prevew`} icon="redo" autosize={true}
            style={{width: 200}}
            size="sm"
              searchable={true}
              // placeholder={<Icon name="redo" size={22} />}
              input={{
                size: 'lg',
                name: "test",
                icon: "redo",
                value: 1,
                placeholder: "df"
                // onChange: this.setValue
              }} options={getCountries()}
            />


            <div style={{display: 'flex', alignItems: 'center'}}>
              <Button appearance="flatten">English</Button>&nbsp;&nbsp;|&nbsp;&nbsp;
              <Button appearance="flatten" style={{opacity: 0.4}}>Belgian</Button>
            </div>


            <Button appearance="outline" size="sm"
            >
              <Icon name="download" />
              Download PDF
              </Button>
          </div>
        </FormGroup>

        <div style={{
          height: "800px",
          backgroundColor: "#F6F9FE",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "50% 0",
          backgroundImage: fakeLoader ? 'url("https://res.cloudinary.com/maiik/image/upload/v1568879969/Xsolla_PA/ref_preview.jpg")' : 'none'
        }}></div>



      </FormGroup>
      </div>

    </FormGroup>
  );
};
